(function () {
  var FOOTER_SELECTOR = '[data-mg-footer-root]';
  var MOBILE_QUERY = '(max-width: 749px), (orientation: landscape) and (max-width: 989px) and (max-height: 520px)';
  var instances = new WeakMap();

  function initFooter(footer) {
    if (!footer || instances.has(footer)) return;

    var cookieButton = footer.querySelector('[data-mg-cookie-preferences]');
    var toggles = Array.prototype.slice.call(footer.querySelectorAll('[data-mg-footer-toggle]'));
    var mobileQuery = window.matchMedia(MOBILE_QUERY);
    var cleanups = [];

    function addListener(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(function () { target.removeEventListener(type, handler, options); });
    }

    function getPanel(toggle) {
      var id = toggle.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    function setMobileMode(enabled) {
      footer.classList.toggle('mg-footer--accordion-ready', enabled);

      toggles.forEach(function (toggle) {
        var panel = getPanel(toggle);
        toggle.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = enabled;
      });
    }

    function syncAccordionMode() {
      setMobileMode(mobileQuery.matches);
    }

    function togglePanel(event) {
      if (!mobileQuery.matches) return;

      var toggle = event.currentTarget;
      var panel = getPanel(toggle);
      if (!panel) return;

      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.hidden = expanded;
    }

    function openCookiePreferences() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        return;
      }

      var fallbackTrigger = document.createElement('a');
      fallbackTrigger.href = '#shopifyReshowConsentBanner';
      fallbackTrigger.hidden = true;
      document.body.appendChild(fallbackTrigger);
      fallbackTrigger.click();
      fallbackTrigger.remove();
    }

    toggles.forEach(function (toggle) {
      addListener(toggle, 'click', togglePanel);
    });

    if (cookieButton) addListener(cookieButton, 'click', openCookiePreferences);

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncAccordionMode);
      cleanups.push(function () { mobileQuery.removeEventListener('change', syncAccordionMode); });
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(syncAccordionMode);
      cleanups.push(function () { mobileQuery.removeListener(syncAccordionMode); });
    }

    syncAccordionMode();

    instances.set(footer, function cleanup() {
      cleanups.forEach(function (fn) { fn(); });
      footer.classList.remove('mg-footer--accordion-ready');
      toggles.forEach(function (toggle) {
        var panel = getPanel(toggle);
        toggle.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = false;
      });
      instances.delete(footer);
    });
  }

  function destroyFooter(footer) {
    var cleanup = footer && instances.get(footer);
    if (cleanup) cleanup();
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var footers = [];

    if (root.matches && root.matches(FOOTER_SELECTOR)) footers.push(root);
    Array.prototype.push.apply(footers, Array.prototype.slice.call(root.querySelectorAll(FOOTER_SELECTOR)));
    footers.forEach(initFooter);
  }

  function destroyAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var footers = [];

    if (root.matches && root.matches(FOOTER_SELECTOR)) footers.push(root);
    Array.prototype.push.apply(footers, Array.prototype.slice.call(root.querySelectorAll(FOOTER_SELECTOR)));
    footers.forEach(destroyFooter);
  }

  if (!window.__MiniGearFooterAssetLifecycle) {
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target || document); });
    document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target || document); });
    window.__MiniGearFooterAssetLifecycle = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
})();
